var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"kt-menu__nav"},[_vm._l((_vm.menuItems),function(menu,i){return [_c('KTMenuItem',{key:i,attrs:{"menu":menu}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }